export default __webpack_public_path__ + "static/media/odp.9c7a2ae5.svg";